import { ref } from 'vue';
import ar from 'date-fns/locale/ar-SA';
import enUS from 'date-fns/locale/en-US';
import { format } from 'date-fns';

// Reading this ref inside computed date labels also refreshes them on a switch.
const selectedLocale = ref(null);

export const setDateLocale = locale => {
  selectedLocale.value = locale;
};

export const getDateLocale = () =>
  selectedLocale.value?.split(/[-_]/)[0] === 'ar' ? ar : enUS;

export const getIntlLocale = () => {
  const selected = selectedLocale.value?.replace(/_/g, '-');
  const browser =
    (typeof navigator !== 'undefined' && navigator.language) || '';
  // Plain "en" keeps the browser's regional date format (e.g. en-GB).
  if (!selected || (selected === 'en' && browser.startsWith('en-'))) {
    return browser || 'en';
  }
  return selected;
};

export const formatLocalizedDate = (date, pattern) =>
  format(date, pattern, { locale: getDateLocale() });
